var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusViewed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45366 33.902C6.0905 33.3269 5.90891 33.0394 5.80726 32.5959C5.73091 32.2628 5.73091 31.7375 5.80726 31.4044C5.90891 30.9609 6.09049 30.6734 6.45366 30.0984C9.45474 25.3464 18.3877 13.3335 32.0011 13.3335C45.6144 13.3335 54.5474 25.3464 57.5485 30.0984C57.9117 30.6734 58.0932 30.9609 58.1949 31.4044C58.2712 31.7375 58.2712 32.2628 58.1949 32.5959C58.0932 33.0394 57.9117 33.3269 57.5485 33.902C54.5474 38.6539 45.6144 50.6668 32.0011 50.6668C18.3877 50.6668 9.45475 38.6539 6.45366 33.902Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0011 40.0002C36.4194 40.0002 40.0011 36.4184 40.0011 32.0002C40.0011 27.5819 36.4194 24.0002 32.0011 24.0002C27.5828 24.0002 24.0011 27.5819 24.0011 32.0002C24.0011 36.4184 27.5828 40.0002 32.0011 40.0002Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusViewed);
export default __webpack_public_path__ + "static/media/status-viewed.a51e6ff2a69fdbd793049fc3751621ec.svg";
export { ForwardRef as ReactComponent };